import * as api from "@/common/api";
import { FamilyEventRequest } from "../class";

/**
 * 경조사 목록 조회 (검색 필터 포함)
 */
export const getFamilyEventList = async (params?: any) => {
  const res = await api.get(
    "/api/v1/family-event/list",
    params || null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};

/**
 * 경조사 상세 조회
 */
export const getFamilyEvent = async (id: number) => {
  const res = await api.get(
    "/api/v1/family-event/" + id,
    null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};

/**
 * 경조사 등록
 */
export const createFamilyEvent = async (payload: FamilyEventRequest) => {
  const res = await api.post("/api/v1/family-event", payload);
  return res.data;
};

/**
 * 경조사 수정
 */
export const updateFamilyEvent = async (
  id: number,
  payload: FamilyEventRequest
) => {
  const res = await api.put("/api/v1/family-event/" + id, payload);
  return res.data;
};

/**
 * 경조사 삭제
 */
export const deleteFamilyEvent = async (id: number) => {
  const res = await api.remove("/api/v1/family-event/" + id);
  return res.data;
};
